import { create } from 'zustand';

export type NotificationKind = 'info' | 'success' | 'warning' | 'danger';
export type PaletteMode = 'closed' | 'commands' | 'panels';

export interface Notification {
  id: string;
  kind: NotificationKind;
  title: string;
  message?: string;
  /** `0` means the notification stays until dismissed. */
  durationMs: number;
}

interface UIState {
  paletteMode: PaletteMode;
  missionWizardOpen: boolean;
  educationCenterOpen: boolean;
  educationTermId: string | null;
  notifications: Notification[];
  openPalette: (mode: 'commands' | 'panels') => void;
  closePalette: () => void;
  setMissionWizardOpen: (open: boolean) => void;
  openEducationCenter: (termId?: string) => void;
  closeEducationCenter: () => void;
  notify: (input: {
    kind: NotificationKind;
    title: string;
    message?: string;
    durationMs?: number;
  }) => string;
  dismiss: (id: string) => void;
}

let notificationSequence = 0;

export const useUiStore = create<UIState>((set) => ({
  paletteMode: 'closed',
  missionWizardOpen: false,
  educationCenterOpen: false,
  educationTermId: null,
  notifications: [],
  openPalette: (mode) => set({ paletteMode: mode }),
  closePalette: () => set({ paletteMode: 'closed' }),
  setMissionWizardOpen: (missionWizardOpen) => set({ missionWizardOpen }),
  openEducationCenter: (educationTermId) =>
    set({ educationCenterOpen: true, educationTermId: educationTermId ?? null }),
  closeEducationCenter: () => set({ educationCenterOpen: false }),
  notify: (input) => {
    const id = `notif-${(notificationSequence += 1)}`;
    const notification: Notification = { id, durationMs: 5000, ...input };
    set((state) => ({ notifications: [...state.notifications, notification] }));
    return id;
  },
  dismiss: (id) => set((state) => ({ notifications: state.notifications.filter((n) => n.id !== id) })),
}));
